<div class="custom-scroll-parent">
  <div
    class="results-menu-scroll custom-scroll lightblue-scrollbar-track gpx-16"
    [class.collapsed]="collapsed"
    [ngClass]="{ 'gpt-32 gpb-24': mobile }"
  >
    <app-card-nav-item
      *ngIf="dashboardLink.visible"
      class="d-block gmb-16"
      [class.collapsed]="collapsed"
      [url]="dashboardLink.url"
      [icon]="dashboardLink.icon"
      [title]="dashboardLink.title"
      (clicked)="navItemClick(dashboardLink.dataTrack)"
    >
    </app-card-nav-item>
    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-0"
    >
      <span>{{ 'RESULTS.MENU.ALL.DNA_INSIGHTS' | translate }}</span>
    </p>
    <ng-container *ngFor="let item of dnaLinks">
      <app-card-nav-item
        *ngIf="item.visible"
        class="d-block gmb-8"
        [url]="item.url"
        [fragment]="item.fragment"
        [title]="item.title"
        [icon]="item.icon"
        [isNew]="item.new"
        [isNewAnalyses]="item.newAnalyses"
        [class.collapsed]="collapsed"
        (clicked)="navItemClick(item.dataTrack)"
      ></app-card-nav-item>
    </ng-container>

    <div class="d-none d-md-block border-bottom gmt-8 w-100"></div>

    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-8"
    >
      <span class="collapsed-name" [class.collapsed]="collapsed">
        {{ 'RESULTS.MENU.ALL.LIFESTYLE_INSIGHTS' | translate }}
      </span>
    </p>
    <ng-container *ngFor="let item of lifestyleLinks">
      <app-card-nav-item
        *ngIf="item.visible"
        class="d-block gmb-8"
        [url]="item.url"
        [fragment]="item.fragment"
        [title]="item.title"
        [icon]="item.icon"
        [isNew]="item.new"
        [isNewAnalyses]="item.newAnalyses"
        [class.collapsed]="collapsed"
        (clicked)="navItemClick(item.dataTrack)"
      ></app-card-nav-item>
    </ng-container>

    <div class="d-none d-md-block border-bottom gmt-8 w-100"></div>

    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-8"
    >
      <span class="collapsed-name" [class.collapsed]="collapsed">
        {{ 'RESULTS.MENU.ALL.FEATURES' | translate }}
      </span>
    </p>
    <ng-container *ngFor="let item of featureLinks">
      <app-card-nav-item
        *ngIf="item.visible"
        class="d-block gmb-8"
        [url]="item.url"
        [fragment]="item.fragment"
        [title]="item.title"
        [icon]="item.icon"
        [isNew]="item.new"
        [isNewAnalyses]="item.newAnalyses"
        [class.collapsed]="collapsed"
        (clicked)="navItemClick(item.dataTrack)"
      ></app-card-nav-item>
    </ng-container>
  </div>
</div>
